export default {
    lang: {
        name: 'Player count'
    }
}